import React from 'react';
import './producto.css';

function createSkeleton() {
  return (
    <div className='skeleton-producto'>
      <h2> </h2>
    </div>
  );
}

const Producto = (props) => {
  const { data, ofertaVoucherData } = props;
  if (!data) {
    return createSkeleton();
  }

  const prodDetailUrl = `${process.env.RAZZLE_URL_PATH}/open-voucher/producto-detalle/${ofertaVoucherData.tipoVoucher.id}/${ofertaVoucherData.id}/${data.producto.id}`;
  const isValid = (item) => item && item !== '' && item !== ' ';

  return (
    <div className='item-producto'>
      <div className='col-md-5 col-sm-12'>
        <div className='row'>
          <div className='position-relative'>
            {isValid(data.producto.label) && (
              <span className='label-info'>
                <span className='text'>{data.producto.label}</span>
              </span>
            )}
            <img
              loading='lazy'
              className='prod-img img-responsive'
              src={data.producto.imagenUrl}
              alt=''
            />
          </div>
        </div>
      </div>
      <div className='col-md-7 col-sm-12'>
        <div className='row'>
          <div className='col-md-7 col-sm-12'>
            <div className='product-information'>
              <div className='title-first'><b>{data.producto.nombre}</b></div>
              <div className='title-second'>
                {data.producto.localidad}
                {' '}
                |
                {' '}
                {data.producto.provincia}
                {' '}
              </div>
              <div className='category'>
                {data.producto.categoria}
                {' '}
                <span className='extra'>{data.producto.extras}</span>
              </div>
              <div className='description'>
                {data.producto.descripcion}
              </div>
              ...
              {' '}
              <br />
              <a
                target='_blank'
                rel='noopener noreferrer'
                href={prodDetailUrl}
                className='color-dinamico'
              >
                Ver más
              </a>
              <div className='acomodations' />
            </div>
          </div>
          <div className='col-md-5 col-sm-12'>
            <div className='prod-actions'>
              <div className='prod-name'>
                Producto incluido en
                {' '}
                <b>
                  Open Voucher
                  {ofertaVoucherData.tipoVoucher.descripcion}
                </b>
              </div>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href={prodDetailUrl}
                className='more-details color-dinamico-fondo'
              >
                Ver detalle
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className='clearfix' />
    </div>
  );
};

export default Producto;
